<!--
    file type .....: HTML file: newmessage.component.html
    Created By ....: ianday
    Date ..........: 1/10/24 
-->
<div class="newmessage-container">

        <div id="messageLHSId" class="half-containers">
            <div style="color:blue; font-style:italic; width: 100%; padding-bottom: 13px;">
                1. Select a message from the list below
            </div>

            <div class="filter-div-class">
                <label>Filter: </label>
                <input type="search"
                       (input)="applyFilter($event.target.value)"
                       (keyup)="applyFilter($event.target.value)"
                       class="filter-input-class-override">
            </div>
            <div style="width:100%; height:5px; background-color:white"></div>
            <div class="table-container mat-elevation-z1"
                 (keydown)="tableKeyDown($event)" tabindex="-1">

                <table mat-table [dataSource]="dataSource" style="width:100%" matSort
                       (matSortChange)="onSortChange($event)">

                    <!-- date Sent -->
                    <ng-container matColumnDef="id">
                        <th mat-header-cell *matHeaderCellDef [hidden]="true"
                            class="mat-table-header-style-dark mat-table-header-style-override "
                            style="width:30%">Category
                        </th>
                        <td mat-cell class="mat-table-detail-override" [hidden]="true"
                            style="width:30%!important;"
                            *matCellDef="let element;let tableRowIdx = index;">
                            {{ element.id}}
                        </td>
                    </ng-container>

                    <!-- date Sent -->
                    <ng-container matColumnDef="messageCategory">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header
                            class="mat-table-header-style-dark mat-table-header-style-override "
                            style="width:30%">Category
                        </th>
                        <td mat-cell class="mat-table-detail-override"
                            style="padding-left: 3px; width:30%!important;"
                            *matCellDef="let element;let tableRowIdx = index;">
                            {{ element.messageCategory}}
                        </td>
                    </ng-container>

                    <!-- subject -->
                    <ng-container matColumnDef="subject">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header
                            class="mat-table-header-style-dark mat-table-header-style-override "
                            style="width: 70%">
                            Subject
                        </th>
                        <td mat-cell class="mat-table-detail-override" style="width:70%"
                            *matCellDef="let element;let tableRowIdx = index;">
                            {{ element.subject }}
                        </td>
                    </ng-container>

                    <!-- Recipients -->
                    <ng-container matColumnDef="sentTo">
                        <th mat-header-cell *matHeaderCellDef
                            class="mat-table-header-style-dark mat-table-header-style-override "
                            style="width:200px;">Recipients
                        </th>
                        <td mat-cell class="mat-table-detail-override" style="width:200px!important;"
                            *matCellDef="let element">{{ element.sentTo }}
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                    <tr mat-row
                        *matRowDef="let row; columns: displayedColumns; let tableRowIdx = index;"
                        [ngClass]="{'row-selected': tableRowIdx == Idx}"
                        (click)="onRowClicked(row)">
                    </tr>
                </table>
                <app-dw-spinner [visible]="busyCursor"></app-dw-spinner>
            </div>
        </div>

        <mat-divider [vertical]="true" class="divider-line-class"></mat-divider>
        <div id="messageRHSId" class="half-containers">
            <div style="color:blue; font-style:italic; width: 100%; padding-bottom: 5px;">
                2. Make adjustments and then 3. click the 'Send' button
            </div>
            <div class="dwform">
                <div class="dwform-row-gap"></div>
                <div class="dwform-row">
                    <label class="label-field"
                           style="font-size: 9pt; width: 80px;">Subject:</label>
                    <span class="form-required"></span>
                    <input class="input-field-long" id="subjectId"
                           [disabled]="!editEnabled"
                           style="width: 400px"
                           [(ngModel)]="subject"
                           type="text" />
                </div>
                <div class="dwform-row-gap"></div>
                <div class="dwform-row">
                    <label class="label-field label-field-override"
                           style="width: 80px;">To:</label>
                    <span class="form-required">*</span>
                    <textarea class="send-to-cc-textarea-override" id="sendToId"
                              [disabled]="!editEnabled"
                           placeholder="<Recipients separated by semi-colons>"
                           [(ngModel)]="sendTo" type="text"></textarea>
                </div>

                <div class="dwform-row-gap"></div>
                <div class="dwform-row">
                    <label class="label-field label-field-override"
                           style="width: 80px;">cc:</label>
                    <span class="form-required"></span>
                    <textarea class="send-to-cc-textarea-override" id="sendCcId"
                              [disabled]="!editEnabled"
                           placeholder="<Recipients separated by semi-colons>"
                           [(ngModel)]="sendCc" type="text"></textarea>
                </div>

                <div class="dwform-row-gap"></div>
                <div class="dwform-row">
                    <label class="label-field label-field-override"
                           style="width: 80px;"></label>
                    <span class="form-required"></span>
                    <mat-checkbox labelPosition="right"
                              [disabled]="!editEnabled"
                              (change)="doIncludeTo($event)"
                              [ngModelOptions]="{standalone: true}"
                              [(ngModel)]="includeUserTo">
                        Include me in the To: section
                    </mat-checkbox>
                </div>

                <div class="dwform-row-gap"></div>
                <div class="dwform-row">
                    <label class="label-field label-field-override"
                           style="width: 80px;"></label>
                    <span class="form-required"></span>
                    <mat-checkbox labelPosition="right"
                              [disabled]="!editEnabled"
                              (change)="doIncludeCc($event)"
                              [ngModelOptions]="{standalone: true}"
                              [(ngModel)]="includeUserCc">
                            Include me in the Cc: section
                    </mat-checkbox>
                </div>

                <div class="dwform-row-gap"></div>
                <div class="dwform-row">
                    <label class="label-field label-field-override"
                           style="width: 80px;"></label>
                    <span class="form-required"></span>
                    <mat-checkbox labelPosition="right"
                                  [disabled]="!editEnabled"
                                  (change)="doIncludeAgencyAdminCc($event)"
                                  [ngModelOptions]="{standalone: true}"
                                  [(ngModel)]="includeAgencyAdminCc">
                        Include the Agency admin in the Cc: section
                    </mat-checkbox>
                </div>
                <div class="dwform-row-double-gap"></div>
                <div class="dwform-row">

                <div style="width: 100%">
                    <label class="label-field" style="padding-bottom: 5px;">Message Content:</label>
                    <div style="display: inline-block; width:74%; text-align:right; padding-bottom: 3px;">
                        <button mat-button class="command-button"
                                [disabled]="Idx <0"
                                matTooltip="Personalize this message"
                                (click)="doPersonalizeMessage()">
                            <mat-icon>favorite_border</mat-icon>Personalize</button>
                    </div>
                </div>
                <textarea class="text-area-input text-area-override"
                          [disabled]="true"
                          [(ngModel)]="messageBody"
                          placeholder="<Email message template>"
                          id="messageBody" ></textarea>
            </div>
        </div>
            <div *ngIf="messageSentVisible" id="copyMessageId" class="sent-message-style">Message Sent!</div>
        <!----------------------->
        <!-- ERROR LINE --------->
        <!----------------------->
        <div class="error-line" [hidden]='!strErr.length'
             style="text-align:left;margin-bottom: 7px;margin-left: 3px;">{{strErr}}</div>
        <!----------------------->
        <!-- SAVE STRIP        -->
        <!----------------------->
        <div class="save-close-strip" style="bottom: 10px;">

            <button mat-button class="command-button"
                    [disabled]="Idx <0 || isSubmitting"
                    (click)="submitRecord()" matTooltip="Send the message"
                    mat-button>
                <mat-icon>email_outline</mat-icon>
                Send
            </button>
            <button mat-button class="command-button"
                    (click)="cancelSubmitRecord()" matTooltip="Close window" mat-button>
                <mat-icon>cancel</mat-icon>
                Close
            </button>
        </div>
    </div>
</div>

<p-dialog header="Personalize Message"
          [focusOnShow]="false" [showHeader]="true"
          [(visible)]="personalizeDlg"
          [style]="{ 'width': '600px', 'height': '600px'}"
          [modal]="true"
          appendTo="body"
          [minY]="35" [resizable]="true" [closable]="true" >
<div>
 <textarea class="text-area-input text-area-override"
           (keydown.enter)="doKeyDownEnter($event)"
           style="height: 470px; white-space: pre-wrap"
           [(ngModel)]="messageBody"
           placeholder="<Email message template>"
           id="messageBodyEditable" ></textarea>
</div>
    <div class="error-line" [hidden]='!strDlgErr.length'
         style="text-align:left;margin-bottom: 8px;margin-left: 3px;">{{strDlgErr}}</div>

    <div class="save-close-strip" style="bottom: 10px;">
        <button mat-button class="command-button"
                [disabled]="Idx <0"
                (click)="doSubmitPersonalizeMessage()" matTooltip="Send the message"
                mat-button>
            <mat-icon>email_outline</mat-icon>
            Save
        </button>
        <button mat-button class="command-button"
                (click)="doCancelPersonalizeMessage()" matTooltip="Close window" mat-button>
            <mat-icon>highlight_off</mat-icon>
            Cancel
        </button>
    </div>

</p-dialog>
